module.exports = __webpack_public_path__ + "static/media/HP_card_brooklyn_portfolio.341f47c7.jpg";